module.exports = __webpack_public_path__ + "static/media/confetti_desktop.309e939d.png";